import React, {
  useCallback, useContext, useState
} from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { useLogin } from '../hooks';

import { AuthUserContext } from './auth-component';
import { Button } from './basic-inputs/button';
import { Input } from './basic-inputs/input';
import { AfterLife } from './logo';

export function LoginComponent() {
  const navigate = useNavigate();
  const { setUser } = useContext(AuthUserContext);
  const { handleLogin, loading } = useLogin();
  const [ error, setError ] = useState('');

  const handleClick = useCallback(async (event) => {
    event.preventDefault();

    const form = event.target.form;
    const data = new FormData(form);

    const payload = {
      email: data.get('email'),
      password: data.get('password')
    };

    if (!payload.email) {
      return setError('Email is required');
    }

    if (!payload.password) {
      return setError('Password is required');
    }

    const user = await handleLogin(payload);

    if (user) {
      setUser(user);
      return navigate('/');
    }

    setError('Invalid email or password');
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="login-page">
      <Link to="/" className="auth-page-header">
        <AfterLife />
      </Link>
      <h2 className="subheader">Log in to continue your journey</h2>
      <p className="error">{error}</p>
      <form>
        <Input id="email" label="Email" required />
        <Input id="password" label="Password" required />
        <br />
        <Button fullWidth onClick={handleClick}>
          Login
        </Button>
      </form>
      <p className="footer">
        Don't have an account? <Link to="/signup">Sign up!</Link>
      </p>
    </div>
  );
}
